import { request } from '@/utils/request'

//生成送货单
export function addSentFormApi(data, that) {
    return request({
        url: '/srm/sentForm/addSentForm',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}
//采购单查询
export function purchaseFormQuery(data, that) {
    return request({
        url: '/srm/purchase/purchaseFormQuery',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}
//采购订单总览查询
export function purchaseFormHeadQuery(data, that) {
    return request({
        url: '/srm/purchase/queryHead',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}
//更新采购订单（子项）接单状态
export function updateAcceptFlagApi(data, that) {
    return request({
        url: '/srm/purchase/updateAcceptFlag',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}
//更新采购订单（单据）接单状态
export function updateFormAcceptFlagApi(data, that) {
    return request({
        url: '/srm/purchase/updateFormAcceptFlag',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}
//添加别名
export function addNameAlias(data, that) {
    return request({
        url: '/srm/anotherMaterialName/addNameAlias',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}
//更新别名
export function updateNameAlias(data, that) {
    return request({
        url: '/srm/purchase/updateNameAlias',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}
//更新采购订单
export function updateErpPurForm(that) {
    return request({
        url: '/erpcaller/formDataController/updateErpPurForm',
        data: {},
        params: {},
        that,
        method: 'get',
    })
}
//更新采购订单状态
export function updateItemStatus(data, that) {
    return request({
        url: '/srm/purchase/updateItemStatus',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}